module.exports = __webpack_public_path__ + "static/media/pay-api.4227dcdc.png";